import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import "./DataEnrich.css";
import DataEnrichUploadModal from "../../Components/DataEnrich/EnrichProspect/DataEnrichUploadModal";
import DataEnrichCard from "../../Components/DataEnrich/DataEnrichCard";
import DataEnrichOrgUploadModal from "../../Components/DataEnrich/EnrichOrganization/DataEnrichOrgUploadModal";
import DataEnrichTable from "../../Components/DataEnrich/DataEnrichTable";
import { APIUrlThree, APIUrlToken, GetUserId } from "../../Utils/Utils";
import Loader from "../../Components/Loader/Loader";
import axios from "axios";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
const DataEnrich = () => {
  const [uploadModal, setUploadModal] = useState(false);
  const [orgUploadModal, setOrgUploadModal] = useState(false);
  const [enrichData, setEnrichData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addToFav, setAddToFav] = useState(false);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const userId = GetUserId();
  const getEnrichList = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_enrich_request?user_id=${userId}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          const sortedData = e?.data?.data
            ?.filter((item) => item?.user_filename !== null)
            ?.sort(
              (a, b) =>
                new Date(b.requested_timestamp) -
                new Date(a.requested_timestamp),
            );
          setEnrichData(sortedData);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getEnrichList();
  }, []);

  const [isTabletView, setIsTabletView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTabletView(width >= 768 && width <= 1024);
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {loading && <Loader />}
      {isTabletView ? (
        <Layout>
          <div>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontStyle: "Bold",
                fontSize: "18px",
                padding: "20px",
              }}
            >
              Data Enrich
            </p>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontStyle: "Bold",
                fontSize: "17px",
                padding: "60px 20px 20px 20px",
                color: "#DA291C",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              {" "}
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: "700",
                  fontStyle: "Bold",
                  fontSize: "18px",
                  color: "#DA291C",
                }}
              >
                {" "}
                Desktop View Required:
              </span>{" "}
              The features on this page are not supported on mobile devices.
              Please switch to a desktop computer for the best experience.
            </p>{" "}
          </div>
        </Layout>
      ) : (
        <Layout className={"paddingSet"}>
          <AiLeadsAction
            setAddToFav={setAddToFav}
            // disableTracking={disableTracking}
            // currentLeadsLength={currentLeadsLength}
            // setIsSalesForceTrigger={setIsSalesForceTrigger}
            // isSalesForceTrigger={isSalesForceTrigger}
            // setIsDecisionMakerExcel={setIsDecisionMakerExcel}
            // statsCountDecisionMaker={statsCountDecisionMaker}
            // setArchiveRecord={setArchiveRecord}
            // setTrackRecord={setTrackRecord}
            // setAddToFav={setAddToFav}
            // setRequestUpdateRecord={setRequestUpdateRecord}
            // disableRequestUpdate={disableRequestUpdate}
            // showSalesForce={showSalesForce}
          />
          <DataEnrichCard
            setUploadModal={setUploadModal}
            uploadModal={uploadModal}
            setOrgUploadModal={setOrgUploadModal}
            orgUploadModal={orgUploadModal}
          />
          <DataEnrichTable
            enrichData={enrichData}
            setLoading={setLoading}
            getEnrichList={getEnrichList}
            setAddToFav={setAddToFav}
            addToFav={addToFav}
          />
          <DataEnrichUploadModal
            modalOpen={uploadModal}
            handleClose={() => setUploadModal(false)}
            setUploadModal={setUploadModal}
            getEnrichList={getEnrichList}
          />
          <DataEnrichOrgUploadModal
            modalOpen={orgUploadModal}
            handleClose={() => setOrgUploadModal(false)}
            setOrgUploadModal={setOrgUploadModal}
            getEnrichList={getEnrichList}
          />
        </Layout>
      )}
    </>
  );
};
export default DataEnrich;
